<template>
    <div class="result-box">

         <div class="beforeAjax" v-if="lists && !lists.itemList.length && !firstTab">暂无数据</div>

        <div class="h-list flexBox" @click="viewAllDaily" v-if="firstTab">
            <div class="q_title_item">近期知识日报查看</div>
            <img class="q_title_icon" src="/static/images/icon/NEW.svg" v-if="!latestIsRead && $store.state.global.newDaily">
            <div class="q_title_blank flexItem"></div>
            <div class="q_title_arrow"></div>
        </div>
        <template v-if="lists && lists.itemList.length">
            
            <div class="h-list" v-for="(list, index) in lists.itemList" :typeId="list.KBTypeId" @click="viewDetail(list.KBTypeId, list.KBInfoId, list)">
                <div class="q_title_item">{{ list.Title }}</div>
                <div class="analyse-info">
                    <span>{{ list.TotalViewCount | validCount }}人浏览</span>
                    <span class="ml-10" v-if="list.KBTypeId === 1 || list.KBTypeId === 2">{{ list.TotalCollectionCount | validCount }}人收藏</span>
                </div>
            </div>

            <div class="load-more-box" v-if="lists.noMore">
                <p class="noMore">没有更多了</p>
            </div>
            <loading-more v-else></loading-more>
        </template>

    </div>
</template>

<script>
    import { COMMON } from '@/api'
    import loadingMore from '@/components/loadingMore'
    export default {
        name: 'resultList2',
        data () {
            return {
                latestDaily: [],
                latestIsRead: true  // 两周内最新一篇日报是否读过
            }
        },
        props: [
            'lists',
            'LogId',
            'firstTab'
        ],
        components: { loadingMore },
        mounted () {
            this.$store.commit('ACTIVE_QID', null)
            if (this.firstTab) {  // 第一个Tab
                COMMON.GetRecentDailys().then( (res) => {
                    if (res.Code === 200 && res.Data && res.Data.List) {
                        this.latestIsRead = res.Data.List.length ? res.Data.List[0].IsRead : true
                    }
                })
            }
        },
        methods: {
            viewAllDaily() {  // 查看近期知识日报
                this.$router.push({
                    path: '/recentDailyReport'
                })
            },
            viewDetail(typeId, caaId, item) {
                try {
                    COMMON.UpdateTopicViewData({
                        LogId: this.LogId,
                        KBInfoId: item.KBInfoId,
                        KBName: item.Title
                    })
                }
                catch (e) {
                    console.log(e);
                }


                // // typeId === 1 ? this.$router.push({ name: 'knowledge', params: { uuid: uuid } }) : this.$router.push({ name: 'faq', params: { uuid: uuid } })
                // if(typeId === 1){ //跳知识详情
                //     this.$router.push({ name: 'knowledge', params: { uuid: caaId } })
                // }else if(typeId === 0){ //跳最新跟新知识详情
                //     // this.$router.push({name:'latestDetail',params: { uuid: caaId } });
                //     this.$router.push({name:'latestDetail',params:{uuid:caaId}});
                //     // this.$router.push({name:'latestDetail' });
                // }else{  //跳常见问题详情
                //    this.$router.push({ name: 'faq', params: { uuid: caaId } })
                // }


                // typeId 1-知识点 2-faq 3-日报
                if (typeId === 1) { // 跳知识点详情
                    this.$router.push({ name: 'knowledge', params: { uuid: caaId } })
                } else if (typeId === 3){ // 跳每日更新页面
                    // this.$router.push({name:'latestDetail',params: { uuid: caaId } });
                    this.$router.push({name: 'latestDetail', params: { uuid: caaId } });
                    // this.$router.push({name:'latestDetail' });
                } else {  // 跳常见问题详情
                   this.$router.push({ name: 'faq', params: { uuid: caaId } })
                }


            },
            lookUp(e,data){
                e.stopPropagation();
                this.$router.push({name:'newUpdate',params:{
                    uuId:data.uuid
                }});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .result-box {
        margin: 0 j(50);
    }
    .beforeAjax {
        font-size: j(28);
        text-align: center;
        // color: #999999;
        color: #9B9DA9;
        padding-top: j(20);
    }
    .h-list {
        font-size: j(28);
        color: #363c54;
        padding: j(36) j(0);
        position: relative;
        &:after {
            @include thin-bb(#f0f1f2);
        }

        .q_title_item{
            // color: #333333;
             font-weight:400;
             color: #363C54;
            display: inline-block;

            overflow: hidden;
            text-overflow:ellipsis;
            word-break: break-word;
            display: -webkit-box;
            /*!autoprefixer: off */
            -webkit-box-orient: vertical;
            /*autoprefixer: on */
            -webkit-line-clamp: 2;
        }
        .q_title_icon {
            width: j(70);
            margin-left: j(10);
        }
        .analyse-info {
            margin-top: j(10);
            font-size: j(24);
            color: #9B9DA9;
        }
        .ml-10 {
            margin-left: j(10);
        }
        
        .q_title_arrow {
            display: inline-block;
            width: j(15);
            height: j(15);
            border-top: 1px solid #9b9da9;
            border-right: 1px solid #9b9da9;
            transform: rotate(45deg);
            position: relative;
            right: 3px;
        }
    }
    .load-more-box {
        font-size: j(28);
        // color: #666666;
        color: #696D7F;
        padding-bottom: j(100);
        p {
            text-align: center;
            height: j(108);
            line-height: j(108);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/resultList2.vue